module.exports = __webpack_public_path__ + "img/82.8.TSS.9edb4805.png";